import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PostLoginGetApi from "../../../components/Api/PostLoginGetApi";
import UserBasicInfoContext from "../../../components/Context/UserBasicInfoContext";







const HomeComplete = () => {
    const [summary, setSummary] = useState('')
    const [companyList, setCompanyList] = useState([]);

    const userProfile = useContext(UserBasicInfoContext);

    // Get Categories

    useEffect(() => {
        //Get Pendign List
        PostLoginGetApi("requested-pending-company", "", 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setCompanyList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });

        PostLoginGetApi("summary/home", "", 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setSummary(responseData["data"]);
                    return;
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }, []);

    return (
        <>
            {/** First Div --- SUMMARY */}
            <div id="top-balance" className="box-full w-full bg-[#F5F5F5] text-[#222222] p-6 px-8 text-justify rounded-[5px] mb-5">
                <h1 className="font-bold flex justify-center text-3xl">Welcome, {userProfile.name}</h1>


                <div className="loading w-2/3 pt-4 font-semibold float-left hidden">
                    loading...
                </div>

            </div>
            {(companyList?.length > 0) &&
                <>
                    <h5 className="text-xl font-semibold">
                        Requested Pending Company
                    </h5>
                    <div className="flex flex-col w-full pt-5 pb-5">
                        <div className='-m-1.5 pt-0'>
                            <div className='p-1.5 min-w-full inline-block align-middle'>
                                <div className="border rounded-lg shadow">
                                    <table className="min-w-full divide-y divide-gray-200 custom-table-hover">
                                        <thead className='bg-neutral-100'>
                                            <tr className='text-left'>
                                                <th scope="col" className='border-l-2 px-2 py-3 text-center'>SL</th>
                                                <th scope="col" className="px-4 text-center">Company Name</th>
                                                <th scope="col">Email</th>
                                                <th scope="col" className="px-4 text-center">Mobile No</th>
                                                <th scope="col" className="px-4 text-center">Status</th>
                                                <th scope="col" className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className='divide-y divide-gray-200'>
                                            {companyList?.map((data, index) => {
                                                let status = "Pending";
                                                if (data?.status == 1) {
                                                    status = "Active";
                                                }
                                                return <tr>
                                                    <td className='border-r-2 text-center'>{index + 1}</td>
                                                    <td className='border-r-2 pl-5'>{data.company_name}</td>
                                                    <td className='border-r-2 pl-5'>{data.email_address}</td>
                                                    <td className='border-r-2 text-center'>{data.mobile_number}</td>
                                                    <td className='border-r-2 text-center'>{status}</td>
                                                    <td className='border-l-2 px-2 py-3 text-center' align="center">
                                                        <Link to={"/dashboard/edit-myreq-company"} state={{ company_id: data.id }} className="cursor-pointer block py-2 px-10 hover:bg-green-100 dark:hover:bg-green-600 bg-green-500 text-white font-semibold dark:hover:text-white text-center" style={{ width:'70px', padding:'5px' }}>Edit</Link>
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div >
                        </div>
                    </div>
                </>
            }
            <div className="w-full flex overflow-hidden text-left py-4 pt-2">
                <div className="box hover-black-green w-[32%] py-5 h-auto mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                    <Link to="/dashboard/company" className="block text-base font-medium">
                        Total Shop
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary.shop_no}</h3>
                </div>

                <div className="box hover-black-green w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >
                    <Link to="/dashboard/user" className="block text-base font-medium">
                        Total User
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary.user_no}</h3>
                </div>



                <div className="box hover-black-green w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >
                    <Link to="/dashboard/voucher" className="block text-base font-medium">
                        Total Voucher
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary.voucher_no}</h3>
                </div>
            </div>

            <div className="w-full flex overflow-hidden text-left py-4 pt-2">
                <div className="box hover-black-green w-[32%] py-5 h-auto mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                    <Link to="/dashboard/orders" className="block text-base font-medium">
                        Total Order
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary.order_no}</h3>
                </div>

                <div className="box hover-black-green w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >
                    <Link to="/dashboard/orders" className="block text-base font-medium">
                        Order Amount
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.order_amount}</h3>
                </div>

                <div className="box hover-black-green w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >
                    <Link to="/dashboard/orders" className="block text-base font-medium">
                        Order Discount
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.order_discount}</h3>
                </div>
            </div>


            <div className="w-full flex overflow-hidden text-left py-4 pt-2">
                <div className="box hover-black-green w-[32%] py-5 h-auto mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                    <Link to="/dashboard/orders" className="block text-base font-medium">
                        Sold Items
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary.order_item_total ?? 0}</h3>
                </div>


                <div className="box hover-black-green w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >
                    <Link to="/dashboard/orders" className="block text-base font-medium">
                        Item Commission
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.order_commission ?? 0}</h3>
                </div>

                <div className="box hover-black-green w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >
                    <Link to="/dashboard/orders" className="block text-base font-medium">
                        Sold Vouchers
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary.voucher_item_total ?? 0}</h3>
                </div>

            </div>

            <div className="w-full flex overflow-hidden text-left py-4 pt-2">
                <div className="box hover-black-green w-[32%] py-5 h-auto mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                    <Link to="/dashboard/orders" className="block text-base font-medium">
                        Voucher Amount
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.voucher_amount ?? 0}</h3>
                </div>

                <div className="box hover-black-green w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >
                    <Link to="/dashboard/orders" className="block text-base font-medium">
                        Voucher Discount
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.voucher_discount ?? 0}</h3>
                </div>

                <div className="box hover-black-green w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >
                    <Link to="/dashboard/orders" className="block text-base font-medium">
                        Voucher Commission
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.voucher_commission ?? 0}</h3>
                </div>

            </div>

            <div className="w-full flex overflow-hidden text-left py-4 pt-2">

                <div className="box hover-black-green w-[32%] py-5 h-auto mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                    <Link to="/dashboard/settlement" className="block text-base font-medium">
                        Settlement Process
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>

                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary.settlement_process ?? 0}</h3>
                </div>

                <div className="box hover-black-green w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >
                    <Link to="/dashboard/settlement" className="block text-base font-medium">
                        Settlement Complete
                        <svg className="ml-1 display-revert" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15L12.5 10L7.5 5" stroke="#222222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>
                    <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{summary.settlement_complete ?? 0}</h3>
                </div>

                <div className="box w-[32%] py-5 h-auto ml-[1%] mr-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5" >

                </div>


            </div>
        </>
    );
}



export default HomeComplete;